/* global pca */
/* eslint-disable no-bitwise */
import $ from 'jquery';

class Loqate {
    constructor () {
        this.options = {
            key      : 'ER43-PY21-UB93-EK58',
            bar      : {
                showCountry: true,
                visible    : true,
            },
            minSearch: 3,
        };

        if ($('.js-form').length) {
            this.initAddressLookups();
        }
    }

    static getMailingFields (prefix = '') {
        return [
            {element: `${prefix}find_mailing_address`, field: 'Search', mode: pca.fieldMode.SEARCH},
            {element: `${prefix}mailing_address1`, field: 'Line1', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address2`, field: 'Line2', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address3`, field: 'Company', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address_city`, field: 'City', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address_state`, field: 'State', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address_county`, field: 'Province', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address_post_code`, field: 'PostalCode', mode: pca.fieldMode.POPULATE},
            {element: `${prefix}mailing_address_country`, field: 'CountryName', mode: pca.fieldMode.POPULATE | pca.fieldMode.COUNTRY},
        ];
    }

    static getInstitutionFields (prefix = '') {
        return [
            {element: `${prefix}find_work_address`, field: 'Search', mode: pca.fieldMode.SEARCH},
            {element: `${prefix}institution`, field: 'Company', mode: pca.fieldMode.POPULATE},
        ];
    }

    initAddressLookups () {
        this.initProfileAddressLookup();
        this.initEventAddressLookups();
        this.initDirectDebitAddressLookup();
    }

    // Account creation form OR Edit profile form.
    initProfileAddressLookup () {
        if ($('.js-register-submit').length || $('.js-edit-submit').length) {
            // Mailing address autocomplete.
            const mailingAddressControl = new pca.Address(Loqate.getMailingFields(), this.options);

            mailingAddressControl.listen('populate', (address, variations) => {
                $('#mailing_address1').trigger('change');
            });

            // Institution autocomplete.
            const institutionAddressControl = new pca.Address(Loqate.getInstitutionFields(), this.options);

            institutionAddressControl.listen('populate', (address, variations) => {
                $('#institution').trigger('change');
            });
        }
    }

    // Event Registration form.
    initEventAddressLookups () {
        if ($('.js-delegate-wrapper').length) {
            const delegates = [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
            ];

            for (let i = 0; i < delegates.length; i++) {
                const delegate = delegates[i];

                // Mailing address autocomplete.
                const mailingAddressControl = new pca.Address(Loqate.getMailingFields(`del${delegate}_`), this.options);

                mailingAddressControl.listen('populate', (address, variations) => {
                    $(`#del${delegate}_mailing_address1`).trigger('change');
                });

                // Institution autocomplete.
                const institutionAddressControl = new pca.Address(Loqate.getInstitutionFields(`del${delegate}_`), this.options);

                institutionAddressControl.listen('populate', (address, variations) => {
                    $(`#del${delegate}_institution`).trigger('change');
                });
            }
        }
    }

    // Direct debit form.
    initDirectDebitAddressLookup () {
        if ($('#variable_ddi_address_line_1').length) {
            const directDebitAddressControl = new pca.Address(
                [
                    {element: 'find_home_address', field: 'Search', mode: pca.fieldMode.SEARCH},
                    {element: 'variable_ddi_company_name', field: 'Company', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_address_line_1', field: 'Line1', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_address_line_2', field: 'Line2', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_address_line_3', field: 'Line3', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_town', field: 'City', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_county', field: 'Province', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_postcode', field: 'PostalCode', mode: pca.fieldMode.POPULATE},
                    {element: 'variable_ddi_country', field: 'CountryName', mode: pca.fieldMode.POPULATE | pca.fieldMode.COUNTRY},
                ],
                this.options,
            );

            directDebitAddressControl.listen('populate', (address, variations) => {
                $('#variable_ddi_address_line_1').trigger('change');
            });
        }
    }
}

export default Loqate;
